import React from 'react';
import PropTypes from 'prop-types';

// Style and SEO
import { styled, thd } from '@smooth-ui/core-sc';
import Helmet from 'react-helmet';
import LoadingAnimation from '_platform/src/components/Loading/LoadingAnimation';
import { withSettings } from '../../containers/WebApp/SettingsContext';
import PrivateComponent from '_platform/src/utils/PrivateComponent';

import Instructions from 'components/CustomComponents/Instructions/Instructions';

import BgHeader from 'components/CustomComponents/Backgrounds/BgHeader';
import Max from '../../theme/max@2x.png';
import BgGradient from 'components/CustomComponents/Backgrounds/BgGradient';

import PromoBanner from 'components/CustomComponents/Banners/PromoBanner';
import Promo from './images/HomePage-PromoBanner-text.png';
import PromoMobile from './images/HomePage-PromoBanner-text-mobile.png';
import PromoBg from './images/HomePage-PromoBanner-bg.jpg';

import LoadAsync from '_platform/src/utils/LoadAsync';
import BgSecondary from 'components/CustomComponents/Backgrounds/BgSecondary';

const RewardsProvider = LoadAsync(() =>
  import(
    /* webpackChunkName: "rewardsProvider" */ '../RewardsProvider/RewardsProvider'
  )
);

const StatementProvider = LoadAsync(() =>
  import(
    /* webpackChunkName: "statementProvider" */ '../StatementProvider/StatementProvider'
  )
);

const StatementSummary = LoadAsync(() =>
  import(
    /* webpackChunkName: "statementLoyalty" */ '../../components/StatementLoyalty/StatementSummary'
  )
);

const PageContainer = styled.div`
  .rewards-button {
    color: #fff;
    font-weight: bold;
    padding: 0.5rem 3rem;
  }

  .rewards-list-item-content {
    border: 1px solid ${thd('secondary', '#fff')};
  }

  .browse--button {
    font-weight: bold;
    padding: 0.5rem 3rem;
    color: #fff;
  }

  .category-container {
    display: block;
    padding: 0;
    margin: 0;
  }

  .category-image {
    margin: 0;
    padding: 0;
    display: inline-block;
  }

  .category-name {
    margin-top: 0;
    background-color: ${thd('secondary', '#fff')};
    color: #fff;
    font-size: 18px;
    font-weight: bold;
    padding: 0.35rem 0;
    display: inline-block;
    width: 100%;
  }

  .statement-container {
    .statement-summary-header {
      display: none;
    }
  }
`;

const HomePage = ({ settings }) => {
  return (
    <PageContainer>
      <Helmet>
        {/* <meta name="description" content="Page description" /> */}
      </Helmet>

      <PrivateComponent
        redirectOnError={{
          pathname: settings.settingsApp.loginPagePath || '/login/',
        }}
      >
        <BgHeader className="spacer--bottom--large">
          <>
            <h1>
              Welcome To <br className="desktop-only" />
              Heatleys <img src={Max} alt="Max" className="max" /> Rewards
            </h1>
            <h2 className="text--primary spacer--bottom text--center">
              The loyalty program that makes every dollar you spend with
              Heatleys go further.
            </h2>
          </>
        </BgHeader>

        <Instructions className="instructions" />

        <div className="spacer--bottom--large">
          <BgGradient>
            <RewardsProvider
              showFeatured
              rewardLabels={{ highlightHeading: 'Discover & Redeem' }}
            />
          </BgGradient>
        </div>

        <BgHeader className="statement-container">
          <>
            <h3 className="h1 text--uppercase text--center">
              My Points <br />
              Dashboard
            </h3>
            <StatementProvider
              fetch={[
                {
                  endpoint: '/Statement/v1/Loyalty/Stealth',
                  section: 'loyalty',
                },
              ]}
              render={({ statement }) =>
                !statement || !statement.data ? (
                  <LoadingAnimation /> // Loader instead of `null`?
                ) : (
                  <StatementSummary
                    statementHideClaimDetails
                    statement={statement.data.loyalty}
                  />
                )
              }
            />
          </>
        </BgHeader>

        <BgSecondary>
          <PromoBanner
            image={Promo}
            mobileImage={PromoMobile}
            bgImage={PromoBg}
            altText="Promo Banner"
          />
        </BgSecondary>
      </PrivateComponent>
    </PageContainer>
  );
};

HomePage.propTypes = {
  settings: PropTypes.object.isRequired,
};

export default withSettings(HomePage);
